var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "UACModal",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal uac-modal",
            "body-class": "p-0",
            title: "User Accounts",
            "hide-footer": "",
            scrollable: "",
          },
          on: {
            show: function ($event) {
              return _vm.initUAC()
            },
            hidden: function ($event) {
              return _vm.resetUACReports()
            },
          },
        },
        [
          _c(
            "b-container",
            { staticClass: "p-0", attrs: { fluid: "" } },
            [
              _c(
                "b-tabs",
                {
                  staticClass: "p-0",
                  attrs: {
                    align: "center",
                    card: "",
                    pills: "",
                    justified: "",
                  },
                },
                [
                  _c(
                    "b-tab",
                    {
                      staticClass: "pt-0",
                      attrs: { title: "User Account Control" },
                    },
                    [
                      _vm.deletedGroupFeedback
                        ? _c(
                            "b-row",
                            {
                              staticClass: "p-2",
                              attrs: { id: "uacDeletedGroupFeedbackWindow" },
                            },
                            [
                              _c("b-col", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  { staticClass: "ml-1" },
                                  [
                                    _c(
                                      "b",
                                      { staticClass: "alert alert-danger" },
                                      [
                                        _vm._v(
                                          _vm._s(this.deletedGroupFeedback)
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("fa", {
                                      attrs: { icon: ["fas", "window-close"] },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deletedFeedbackHide()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          staticClass:
                            "p-2 w-100 dflex justify-content-end align-items-center",
                          attrs: { "no-gutters": "" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "user-table-actions" },
                            [
                              _vm.todate || _vm.fromdate
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "btn btn-info text-nowrap w-auto",
                                      attrs: { variant: "danger" },
                                      on: {
                                        click: function ($event) {
                                          _vm.todate = null
                                          _vm.fromdate = null
                                        },
                                      },
                                    },
                                    [_vm._v("Clear")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "form-control col-sm-3 propStyle",
                                attrs: {
                                  type: "date",
                                  placeholder: "From date",
                                  format: "yyyy/mm/dd",
                                },
                                on: { change: _vm.dateChange },
                                model: {
                                  value: _vm.fromdate,
                                  callback: function ($$v) {
                                    _vm.fromdate = $$v
                                  },
                                  expression: "fromdate",
                                },
                              }),
                              _vm._v(" "),
                              _c("label", { staticClass: "pt-2" }, [
                                _vm._v("TO"),
                              ]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "form-control col-sm-3 propStyle",
                                attrs: {
                                  type: "date",
                                  placeholder: "To date",
                                  format: "yyyy/mm/dd",
                                },
                                on: { change: _vm.dateChange },
                                model: {
                                  value: _vm.todate,
                                  callback: function ($$v) {
                                    _vm.todate = $$v
                                  },
                                  expression: "todate",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "b-form-checkbox-group",
                                {
                                  staticClass: "checkboxes",
                                  staticStyle: { width: "auto" },
                                  model: {
                                    value: _vm.statuses,
                                    callback: function ($$v) {
                                      _vm.statuses = $$v
                                    },
                                    expression: "statuses",
                                  },
                                },
                                [
                                  _c(
                                    "b-form-checkbox",
                                    { attrs: { size: "lg", value: false } },
                                    [_vm._v("Inactive")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-checkbox",
                                    { attrs: { size: "lg", value: true } },
                                    [_vm._v("Active")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass:
                                    "btn btn-info text-nowrap w-auto",
                                  on: { click: _vm.downloadCSV },
                                },
                                [_vm._v("Download CSV")]
                              ),
                              _vm._v(" "),
                              _vm.globalIsUserAllowed("New_User")
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "btn btn-success text-nowrap w-auto",
                                      on: {
                                        click: function ($event) {
                                          return _vm.initNewUserModal()
                                        },
                                      },
                                    },
                                    [_vm._v("Add New User")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("vue-bootstrap4-table", {
                        ref: "userTable",
                        attrs: {
                          rows: _vm.filteredUsers,
                          columns: _vm.usersColumns,
                          config: _vm.usersConfig,
                          classes: _vm.classes,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "sortable_date",
                            fn: function (props) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(props.row.last_login_date) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                          {
                            key: "update",
                            fn: function (props) {
                              return [
                                _vm.globalIsUserAllowed("Update_User")
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "info" },
                                        on: {
                                          click: function ($event) {
                                            _vm.$emit(
                                              "updateUser",
                                              parseInt(props.row.id)
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("fa", {
                                          attrs: {
                                            icon: ["fas", "pencil-alt"],
                                            size: "lg",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "inactive",
                            fn: function (props) {
                              return [
                                props.row.inactive != null &&
                                _vm.globalIsUserAllowed("Update_User")
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "transparent",
                                          title: "Activate User",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.activateEntryHandler(
                                              props.row
                                            )
                                          },
                                          mouseover: function ($event) {
                                            _vm.hoveredRowId = props.row.id
                                          },
                                          mouseleave: function ($event) {
                                            _vm.hoveredRowId = null
                                          },
                                        },
                                      },
                                      [
                                        _c("fa", {
                                          class:
                                            _vm.hoveredRowId === props.row.id
                                              ? "green-icon"
                                              : "red-icon",
                                          attrs: {
                                            icon: [
                                              "fas",
                                              _vm.hoveredRowId === props.row.id
                                                ? "lock-open"
                                                : "lock",
                                            ],
                                            size: "lg",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm.globalIsUserAllowed("Update_User")
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "transparent",
                                          title: "Deactive User",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteEntryHandler(
                                              props.row
                                            )
                                          },
                                          mouseover: function ($event) {
                                            _vm.hoveredRowId = props.row.id
                                          },
                                          mouseleave: function ($event) {
                                            _vm.hoveredRowId = null
                                          },
                                        },
                                      },
                                      [
                                        _c("fa", {
                                          class:
                                            _vm.hoveredRowId === props.row.id
                                              ? "red-icon"
                                              : "green-icon",
                                          attrs: {
                                            icon: [
                                              "fas",
                                              _vm.hoveredRowId === props.row.id
                                                ? "lock"
                                                : "lock-open",
                                            ],
                                            size: "lg",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    { attrs: { title: "Permissions" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-dropdown",
                            {
                              staticClass: "date-range",
                              attrs: { text: this.currentTitle },
                            },
                            [
                              _c(
                                "b-dropdown-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeTimePeriod(1)
                                    },
                                  },
                                },
                                [_vm._v("Last 24 Hours")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeTimePeriod(7)
                                    },
                                  },
                                },
                                [_vm._v("Last Week")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeTimePeriod(30)
                                    },
                                  },
                                },
                                [_vm._v("Last Month")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeTimePeriod(90)
                                    },
                                  },
                                },
                                [_vm._v("Last 3 Months")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeTimePeriod(180)
                                    },
                                  },
                                },
                                [_vm._v("Last 6 Months")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeTimePeriod(365)
                                    },
                                  },
                                },
                                [_vm._v("Last Year")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("vue-bootstrap4-table", {
                        attrs: {
                          rows: _vm.permissionsRows,
                          columns: _vm.permissionsColumns,
                          config: _vm.configNoPagination,
                          classes: _vm.classes,
                        },
                      }),
                      _vm._v(" "),
                      _c("b-row", [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "margin-left": "auto",
                              "margin-right": "auto",
                            },
                          },
                          [
                            _vm._v(
                              "\n              Excludes test accounts.\n            "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: { title: "Reports" },
                      on: {
                        click: function ($event) {
                          _vm.recentPeriod =
                            _vm.recentPeriod == "1" ? 1 : _vm.recentPeriod
                        },
                      },
                    },
                    [
                      _c(
                        "b-container",
                        { staticClass: "px-auto" },
                        [
                          _c(
                            "b-row",
                            {
                              staticClass: "py-3",
                              attrs: { "align-v": "center" },
                            },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "btn mx-3 text-nowrap w-auto",
                                      attrs: {
                                        variant: _vm.dayButtonClassCtrl,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeTimePeriod(1)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Last 24 Hours\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "btn mx-3 text-nowrap w-auto",
                                      attrs: {
                                        variant: _vm.weekButtonClassCtrl,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeTimePeriod(7)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Last Week\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "btn mx-3 text-nowrap w-auto",
                                      attrs: {
                                        variant: _vm.monthButtonClassCtrl,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeTimePeriod(30)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Last Month\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "btn mx-3 text-nowrap w-auto",
                                      attrs: {
                                        variant: _vm.quarterButtonClassCtrl,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeTimePeriod(90)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Last 3 Months\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "btn mx-3 text-nowrap w-auto",
                                      attrs: {
                                        variant: _vm.halfYearButtonClassCtrl,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeTimePeriod(180)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Last 6 Months\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "btn mx-3 text-nowrap w-auto",
                                      attrs: {
                                        variant: _vm.yearButtonClassCtrl,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeTimePeriod(365)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Last Year\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        { staticClass: "menu-bg-blue-transparent" },
                        [
                          _c(
                            "b-row",
                            {
                              staticClass: "mt-5",
                              attrs: { "align-h": "center" },
                            },
                            [
                              _c("apexchart", {
                                attrs: {
                                  type: "donut",
                                  width: "650",
                                  options: _vm.loginsOptions,
                                  series: _vm.loginsSeries,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    { attrs: { title: "Test Accounts" } },
                    [
                      _c("vue-bootstrap4-table", {
                        attrs: {
                          rows: _vm.testAccountsRows,
                          columns: _vm.testAccountsColumns,
                          config: _vm.configNoPagination,
                          classes: _vm.classes,
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "center" }, [
                        _c("p", [
                          _vm._v(
                            "\n              The credentials to each test account can be found\n              "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://ushrauto.atlassian.net/wiki/spaces/DRT/pages/2205777921/MMP+Test+Account+Credentials",
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                            },
                            [_vm._v("\n                here.\n              ")]
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    { attrs: { title: "Groups" } },
                    [
                      _vm.deletedGroupFeedback
                        ? _c(
                            "b-row",
                            {
                              staticClass: "py-3",
                              attrs: { id: "groupsDeletedGroupFeedbackWindow" },
                            },
                            [
                              _c("b-col", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  { staticClass: "ml-1" },
                                  [
                                    _c(
                                      "b",
                                      { staticClass: "alert alert-danger" },
                                      [
                                        _vm._v(
                                          _vm._s(this.deletedGroupFeedback)
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("fa", {
                                      attrs: { icon: ["fas", "window-close"] },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deletedFeedbackHide()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.addedGroupFeedback
                        ? _c(
                            "b-row",
                            {
                              staticClass: "py-3",
                              attrs: { id: "groupsAddedGroupFeedbackWindow" },
                            },
                            [
                              _c("b-col", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  { staticClass: "ml-1" },
                                  [
                                    _c(
                                      "b",
                                      { staticClass: "alert alert-success" },
                                      [_vm._v(_vm._s(this.addedGroupFeedback))]
                                    ),
                                    _vm._v(" "),
                                    _c("fa", {
                                      attrs: { icon: ["fas", "window-close"] },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addedFeedbackHide()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.globalIsUserAllowed("New_Operator_Group")
                        ? _c(
                            "b-row",
                            { staticClass: "py-3 ml-2" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "success" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.initNewGroupModal()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Create New Group\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("vue-bootstrap4-table", {
                        attrs: {
                          rows: _vm.groupsRows,
                          columns: _vm.groupsColumns,
                          config: _vm.configNoPagination,
                          classes: _vm.classes,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "group",
                              fn: function (props) {
                                return [
                                  props.row.update &&
                                  _vm.globalIsUserAllowed(
                                    "Update_Operator_Group"
                                  )
                                    ? _c(
                                        "div",
                                        [
                                          _c("b-form-input", {
                                            attrs: { type: "text" },
                                            model: {
                                              value: props.row.group,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  props.row,
                                                  "group",
                                                  $$v
                                                )
                                              },
                                              expression: "props.row.group",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "btn btn-success pt-1",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.changeGroupName(
                                                    props.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("fa", {
                                                attrs: {
                                                  icon: ["fas", "check"],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "btn btn-danger pt-1",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.cancelChangeGroupName(
                                                    props.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("fa", {
                                                attrs: {
                                                  icon: ["fas", "times"],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _c("div", [
                                        _c("span", [
                                          _vm._v(_vm._s(props.row.group)),
                                        ]),
                                      ]),
                                ]
                              },
                            },
                            {
                              key: "update",
                              fn: function (props) {
                                return _vm.globalIsUserAllowed(
                                  "Update_Operator_Group"
                                )
                                  ? [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: "info",
                                            disabled: props.row.group == "None",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateGroup(props.row)
                                            },
                                          },
                                        },
                                        [
                                          _c("fa", {
                                            attrs: {
                                              icon: ["fas", "pencil-alt"],
                                              size: "lg",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : undefined
                              },
                            },
                            {
                              key: "delete",
                              fn: function (props) {
                                return _vm.globalIsUserAllowed(
                                  "Delete_Operator_Group"
                                )
                                  ? [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            disabled: props.row.group == "None",
                                            variant: "danger",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteGroup(props.row)
                                            },
                                          },
                                        },
                                        [
                                          _c("fa", {
                                            attrs: {
                                              icon: ["fas", "minus"],
                                              size: "lg",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "confirmInactiveModal",
            size: "md",
            "content-class": "sub-menu-bg-blue-transparent",
            title: "Deactivate User Confirmation",
            "hide-footer": "",
          },
        },
        [
          _vm.selectedUser
            ? _c(
                "b-container",
                [
                  _c(
                    "b-row",
                    { staticClass: "py-2 text-center" },
                    [
                      _c("b-col", [
                        _vm._v("\n          User with name "),
                        _c("span", { staticClass: "yellow-text" }, [
                          _vm._v(_vm._s(this.selectedUser.name)),
                        ]),
                        _vm._v(" and email "),
                        _c("span", { staticClass: "yellow-text" }, [
                          _vm._v(_vm._s(this.selectedUser.email)),
                        ]),
                        _vm._v(" will be deactivated.  \n        "),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "py-2 text-center" },
                    [
                      _c("b-col", [
                        _vm._v(
                          "\n          Please confirm this action. \n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    {
                      staticClass: "row-input py-2 w-100",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                size: "lg",
                                type: "submit",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteEntry()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Confirm and Submit\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "confirmActiveModal",
            size: "md",
            "content-class": "sub-menu-bg-blue-transparent",
            title: "Activate User Confirmation",
            "hide-footer": "",
          },
        },
        [
          _vm.selectedUser
            ? _c(
                "b-container",
                [
                  _c(
                    "b-row",
                    { staticClass: "py-2 text-center" },
                    [
                      _c("b-col", [
                        _vm._v("\n          User with name "),
                        _c("span", { staticClass: "yellow-text" }, [
                          _vm._v(_vm._s(this.selectedUser.name)),
                        ]),
                        _vm._v(" and email "),
                        _c("span", { staticClass: "yellow-text" }, [
                          _vm._v(_vm._s(this.selectedUser.email)),
                        ]),
                        _vm._v(" will be activated.  \n        "),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "py-2 text-center" },
                    [
                      _c("b-col", [
                        _vm._v(
                          "\n          Please confirm this action. \n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    {
                      staticClass: "row-input py-2 w-100",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                size: "lg",
                                type: "submit",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.activateEntry()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Confirm and Submit\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }